
const SwitchBox = ({ checked, onChange }) => {
  return (
    <label className="relative inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        className="sr-only"
        checked={checked}
        onChange={onChange}
      />
      <div
        className={`w-12 h-6 rounded-full p-1 flex items-center transition-all ${
          checked ? "bg-blue-500" : "bg-gray-300"
        }`}
      >
        <div
          className={`w-5 h-5 bg-white rounded-full shadow-md transform transition ${
            checked ? "translate-x-6" : "translate-x-0"
          }`}
        ></div>
      </div>
    </label>
  );
};

export default SwitchBox;
